import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PurchasesServices = {
  // ✅ Updated getList with SearchText and pagination params
  getList: async ({ SearchText = "", pageNumber = 1, pageSize = 10 } = {}) => {
    const params = new URLSearchParams(
      {
        ...(SearchText && { SearchText: SearchText.toString() }),
        pageNumber: pageNumber.toString(),
        pageSize: pageSize.toString(),
      },
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );

    const response = await apiService.get(
      `/Purchase/GetList?${params.toString()}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },

  create: async (postData) => {
    const response = await apiService.post("/Purchase/Create", postData, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  view: async (id) => {
    const response = await apiService.get("/Purchase/GetDetail?id=" + id, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete("/Purchase/Delete?id=" + id, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  update: async (id, updatedData) => {
    const response = await apiService.patch(
      `/Purchase/Update?id=` + id,
      updatedData,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
};

export default PurchasesServices;
